import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { recentPurchases, PRODUCT_NAME, PRICE } from '../data/content';
const FIRST_DELAY = 12000;
const VISIBLE_FOR = 6000;
const MIN_INTERVAL = 40000;
const MAX_INTERVAL = 60000;
function randomInterval() {
  return MIN_INTERVAL + Math.random() * (MAX_INTERVAL - MIN_INTERVAL);
}
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    if (dismissed || recentPurchases.length === 0) return;
    let current = Math.floor(Math.random() * recentPurchases.length);
    const show = () => {
      setIndex(current);
      setVisible(true);
      timers.current.push(window.setTimeout(() => {
        setVisible(false);
        current = (current + 1) % recentPurchases.length;
        timers.current.push(window.setTimeout(show, randomInterval()));
      }, VISIBLE_FOR));
    };
    timers.current.push(window.setTimeout(show, FIRST_DELAY));
    return () => {
      timers.current.forEach(t => window.clearTimeout(t));
      timers.current = [];
    };
  }, [dismissed]);
  const purchase = recentPurchases[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 flex sm:right-auto" aria-live="polite" data-id="element-159" data-mp="285hcfutezaw2">
      <AnimatePresence data-id="element-160" data-mp="1be6thhpbc6de">
        {visible && !dismissed && purchase && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-2 shadow-[0_20px_40px_-16px_rgba(23,49,59,0.4)] ring-1 ring-brand-100" data-id="element-161" data-mp="1fieh1bk1bga1">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-600 font-display text-base font-extrabold text-white" data-id="element-162" data-mp="200genq41uqql">
              {purchase.name.charAt(0)}
            </span>
            <div className="min-w-0 flex-1" data-id="element-163" data-mp="28wfk763v2y1r">
              <p className="truncate text-sm text-ink" data-id="element-164" data-mp="24s7x1dd1xq5n">
                <strong className="font-semibold" data-id="element-165" data-mp="24uuatuqjd1wb">{purchase.name}</strong> de {purchase.place}
              </p>
              <p className="truncate text-[13px] text-ink-soft" data-id="element-166" data-mp="1h4zydea4pfcl">
                compró {PRODUCT_NAME}™ · {PRICE}
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-brand-700" data-id="element-167" data-mp="1q43k6q0ok8us">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-168" data-mp="1l4h6ygkuqslz" />
                Compra verificada · hace {purchase.minutesAgo} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificaciones" className="flex h-8 w-8 shrink-0 items-center justify-center self-start rounded-full text-ink-soft transition-colors duration-150 ease-out hover:bg-mist hover:text-ink" data-id="element-169" data-mp="2wk5upa5xjvnu">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-170" data-mp="390ez8j9qzcp8" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}